import type { ReactNode } from 'react'

import clsx from 'clsx'

import '@hotmart/cosmos/dist/tag'
import '@hotmart/cosmos/dist/tag/variations/blue.css'
import '@hotmart/cosmos/dist/tag/variations/green.css'
import '@hotmart/cosmos/dist/tag/variations/yellow.css'
import '@hotmart/cosmos/dist/tag/variations/purple.css'
import '@hotmart/cosmos/dist/tag/variations/cyan.css'
import '@hotmart/cosmos/dist/tag/variations/red.css'
import '@hotmart/cosmos/dist/tag/variations/small.css'
import '@hotmart/cosmos/dist/tag/variations/large.css'

export type Variation = 'gray' | 'blue' | 'green' | 'yellow' | 'purple' | 'cyan' | 'red'

export type Size = 'sm' | 'lg'

export type TagProps = {
  children: ReactNode
  variation?: Variation
  size?: Size
  className?: string
  dismissible?: boolean
  'data-test'?: string
  role?: string
}
const Tag = ({
  children,
  className = '',
  'data-test': dataTest = '',
  variation = 'gray',
  size,
  role
}: TagProps) => {
  const tagClass = clsx(
    {
      [`hot-tag--${variation}`]: variation !== 'gray',
      [`hot-tag--${size}`]: size
    },
    className
  )

  return (
    <hot-tag class={tagClass} data-test={dataTest} role={role}>
      {children}
    </hot-tag>
  )
}

export default Tag
